const normalizeText = (text) => {
  switch (text) {
  case 'nocolor':
    return 'No color';
  case 'yellow':
    return 'Yellow';
  case 'blue':
    return 'Blue';
  case 'red':
    return 'Red';
  case 'green':
    return 'Green';
  case 'purple':
    return 'Purple';
  case 'flagged':
    return 'Flagged';
  case 'unflagged':
    return 'Unflagged';
  case 'rejected':
    return 'Rejected';
  case 'audioAndVideo':
    return 'Audio and Video';
  case 'externalLink':
    return 'External links';
  case 'images':
    return 'Images';
  case 'video':
    return 'Video';
  case 'audio':
    return 'Audio';
  case 'text':
    return 'Text documents';
  case 'pdf':
    return 'PDF documents';
  case 'sketch':
    return 'Sketch files';
  case 'raw':
    return 'DSLR RAW photos';
  case 'photoshop':
    return 'Photoshop documents';
  case 'office':
    return 'Office documents';
  case '3d':
    return '3D models';
  default:
    return text;
  }
};

export default normalizeText;
